
import React from "react";
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { STORAGE_URL } from "@/lib/supabase";

interface AlertSectionProps {
  displayImage?: {
    storage_path: string;
    duration: number;
    is_active: boolean;
  } | null;
  showAlertMessage: boolean;
  alertMessage?: string;
  aspectRatio: number;
}

export const AlertSection: React.FC<AlertSectionProps> = ({
  displayImage,
  showAlertMessage,
  alertMessage,
  aspectRatio
}) => {
  return (
    <div 
      className="w-[350px] h-full flex items-center overflow-hidden shrink-0"
      style={{ backgroundColor: "#ffe500" }}
    >
      {displayImage ? (
        <AspectRatio ratio={aspectRatio} className="w-full h-full">
          <img
            src={`${STORAGE_URL}/storage/v1/object/public/alert_images/${displayImage.storage_path}`}
            alt="Alert"
            className="w-full h-full object-cover"
          />
        </AspectRatio>
      ) : showAlertMessage ? (
        <p className="text-black font-bold px-4 text-left text-xl">
          {alertMessage}
        </p>
      ) : null}
    </div>
  );
};
